import moment from "moment";

export const DO_FORMAT = "DD MMM YYYY";
export const DO_FORMAT_REVERSE = "YYYY-MM-DD";
export const ACTUAL_FORMAT = "DD-MM-YYYY HH:mm:ss";
export const DO_FORMAT_TIME_WITH_PIPE = "DD MMM YYYY | HH:mm";
export const HUMAN_READABLE_DATETIME = "DD MMM YYYY";


export const formatDate = (date:any) =>{
    return moment(date, ACTUAL_FORMAT).format(DO_FORMAT);
}

export const formatDateStandard = (date:any) =>{
    return moment(date).format(HUMAN_READABLE_DATETIME);
}

export const formatDefaultDate = (date:any) =>{
    return moment(date).format(DO_FORMAT);
}

export const formatDateWithTimeAndPipe = (date:any) =>{
    return moment(date, ACTUAL_FORMAT).format(DO_FORMAT_TIME_WITH_PIPE);
}

export const getDiffFromToday = (src: any, dest:any, type: string) =>{
    //const src = moment(src);
    //const dest = moment(date, ACTUAL_FORMAT)
    const years = src.diff(dest, "years");
    const months = src.subtract(years, "years").diff(dest, "months");
    const days = src.subtract(months, "months").diff(dest, "days");
    let diff = "";
    switch (type){
        case "ALL" : 
        diff = years > 0 ? `${years} years, ` : ``; 
        diff = diff + (months > 0 ? `${months} months, `: ``);
        diff = diff + `${days} days`;
        break;
        case "Y":
            diff = `${years} years`  
            break;
        case "M":
            diff = `${months} months`
            break;
        case "D":
            diff = `${days} days`
            break;
        case "Y/M/D":
            diff = years > 0 ? `${years} years ` : months > 0 ? `${months} months` : `${days} days`;
            break;
        case "Y-M":
            diff = years > 0 ? `${years} years ${months>0 ? months + " months ": ""}` : months > 0 ? `${months} months ` : `${days} days`;
            break;
    }

    return diff;
    
}

export const numberFormatter = (num:any) => {
    if (num >= 1000000000) {
       return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
       return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
       return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num;
}

// export const toTitleCase = (text:any)=>{
//     return text.replace(/\w\S*/g, function(txt:any){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
// }

export const toPascalCase = (text:any)=>{
    return text.replace(/\w\S*/g, function(txt:any){return txt.charAt(0).toUpperCase() + txt.substr(1);});
}

export const getProgressColorCode = (flag: any) =>{
    return flag === "G" ? "#1bbe75" : flag === "R" ? "#e75547" : flag === "Y" ? "#f2960d" : "#42526e" 
}

export const getProgressColorCodeByPercentage = (percent: number, firstThreshold: number, secondThreshold: number) =>{
    
    return percent > 0 && percent <= firstThreshold  ? "#1bbe75" : true ? "#e75547" : "#f2960d"
}

/**
 * This function returns the initial part of a string as per characterCount
 * @param text : text to be trancate string 
 * @param charactersCount : number of characters to be taken
 * @returns 
 */

export const showInitialPartOfString = (text: string, charactersCount: number) => {
    return text.length > charactersCount ? text.substring(0, charactersCount) + "..." : text
}

//@description this function adds space based on capital letter and coverts to pascal case
export const spacedString = (text : any) => {
    return toPascalCase(text).split(/(?=[A-Z])/).join(' ')
}